"use client";

import { BlogLink, Content, Header } from "@/components/shared/public/blogs";
import { Link } from "@/i18n/navigation";
import { useTranslations } from "next-intl";
import {
  header,
  section1,
  section2,
  section3,
} from "../../../../../../public/images/blogs/createFloorplan";

export default function BlogContent() {
  const t = useTranslations("blogs.createFloorPlan");

  return (
    <>
      <Header
        title={t("header.title")}
        text={t.rich("header.text", {
          link: (chunks) => (
            <Link href="/blog/immobilienmarketing" className="hover:underline">
              {chunks}
            </Link>
          ),
          link1: (chunks) => (
            <Link href="/blog/grundriss" className="hover:underline">
              {chunks}
            </Link>
          ),
          link2: (chunks) => (
            <Link href="/blog/expose" className="hover:underline">
              {chunks}
            </Link>
          ),
          bold: (chunks) => <strong>{chunks}</strong>,
        })}
        src={header}
        alt={t("header.imageAlt")}
      />
      <div className="gs--blog-body flex flex-col gap-10 py-16">
        <Content
          imageFit="cover"
          title={t("sections.section1.title")}
          text={t.rich("sections.section1.text", {
            br: () => <br></br>,
            link: (chunks) => (
              <BlogLink href="/blog/grundriss">{chunks}</BlogLink>
            ),
            link1: (chunks) => (
              <BlogLink href="/blog/grundriss-einer-wohnung">{chunks}</BlogLink>
            ),
            link2: (chunks) => (
              <BlogLink href="/blog/hausgrundriss">{chunks}</BlogLink>
            ),
            link3: (chunks) => (
              <BlogLink href="/blog/cad-system">{chunks}</BlogLink>
            ),
            link4: (chunks) => (
              <BlogLink href="/blog/grundriss-online-zeichnen">
                {chunks}
              </BlogLink>
            ),
            bold: (chunks) => <strong>{chunks}</strong>,
          })}
          src={section1}
          alt={t("sections.section1.imageAlt")}
          imageLeft={true}
        />
        <Content
          imageFit="cover"
          title={t("sections.section2.title")}
          text={t.rich("sections.section2.text", {
            br: () => <br></br>,
            link: (chunks) => (
              <BlogLink href="/blog/grundriss">{chunks}</BlogLink>
            ),
            link2: (chunks) => (
              <BlogLink href="/blog/immogrundriss">{chunks}</BlogLink>
            ),
            link3: (chunks) => (
              <BlogLink href="/blog/grundriss-zeichnen">{chunks}</BlogLink>
            ),
            bold: (chunks) => <strong>{chunks}</strong>,
          })}
          src={section2}
          alt={t("sections.section2.imageAlt")}
        />
        <Content
          title={t("sections.section3.title")}
          text={t.rich("sections.section3.text", {
            br: () => <br></br>,
            link: (chunks) => (
              <BlogLink href="/blog/immobilienmarketing">{chunks}</BlogLink>
            ),
            link1: (chunks) => (
              <BlogLink href="/blog/grundriss-erstellen-lassen">
                {chunks}
              </BlogLink>
            ),
            link2: (chunks) => (
              <BlogLink href="/blog/expose">{chunks}</BlogLink>
            ),
            bold: (chunks) => <strong>{chunks}</strong>,
          })}
          src={section3}
          alt={t("sections.section3.imageAlt")}
          imageLeft={true}
          disclaimer="default"
        />
      </div>
    </>
  );
}
